module.exports = __webpack_public_path__ + "img/sheriff.72b1205c.png";